import {
    IContextState,
    createCategoryContextState,
    createKngContextState,
    createAverageMonthlyIncomeContextState,
    createLocationsContextState,
    createKngSubmittedApplicationsState,
    IKngSubmittedApplicationsState,
    IKngPositionScoresState,
    createKngPositionScoresState,
} from ".."

export const CATEGORIES_KEY = "categories"
export const LOCATIONS_KEY = "locations"
export const KNG_KEY = "kng"
export const AVG_MONTHLY_INCOME_KEY = "average-monthly-income"
export const POSITION_SCORES_KEY = "positionScores"

export interface IContext {
    states: Map<string, IContextState>
    categories: () => IContextState
    locations: () => IContextState
    kng: () => IContextState
    kngSubmittedApplications: () => IKngSubmittedApplicationsState
    avgMonthlyIncome: () => IContextState
    kngPositionScores: () => IKngPositionScoresState
    get: (key: string) => IContextState | undefined
}

export function createContext(): IContext {
    const categoriesState = createCategoryContextState(CATEGORIES_KEY)
    const locationsState = createLocationsContextState(LOCATIONS_KEY)
    const kngState = createKngContextState(KNG_KEY)
    const avgMonthlyIncomeState = createAverageMonthlyIncomeContextState(AVG_MONTHLY_INCOME_KEY)
    const kngSubmittedApplicationsState = createKngSubmittedApplicationsState()
    const kngPositionScoresState = createKngPositionScoresState()
    const states: Map<string, IContextState> = new Map<string, IContextState>()
    states.set(CATEGORIES_KEY, categoriesState)
    states.set(LOCATIONS_KEY, locationsState)
    states.set(KNG_KEY, kngState)
    states.set(AVG_MONTHLY_INCOME_KEY, avgMonthlyIncomeState)

    const categories = () => {
        return states.get(CATEGORIES_KEY)!
    }

    const locations = () => {
        return states.get(LOCATIONS_KEY)!
    }

    const kng = () => {
        return states.get(KNG_KEY)!
    }

    const avgMonthlyIncome = () => {
        return states.get(AVG_MONTHLY_INCOME_KEY)!
    }

    const get = (key: string) => {
        return states.get(key)
    }

    return {
        states,
        categories,
        locations,
        avgMonthlyIncome,
        kng,
        get,
        kngSubmittedApplications: () => kngSubmittedApplicationsState,
        kngPositionScores: () => kngPositionScoresState
    }
}
